export const SavedViewsToolbarStep = {
  header: 'Access your views easily',
  text: 'All you need to do is open a report and select one of the saved report views.',
};

export const MySavedViewsPageStep = {
  header: 'Manage your saved views',
  text: 'See all saved views for each report in one place.',
};
